import React, { useState } from 'react';
import styles from './AudioVolume.module.css';

interface AudioVolumeProps {
  volume: number;
  onVolumeChange: (newVolume: number) => void;
}

const AudioVolume: React.FC<AudioVolumeProps> = ({ volume, onVolumeChange }) => {
  const [prevVolume, setPrevVolume] = useState(volume);

  const handleVolumeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newVolume = parseInt(event.target.value, 10);
    onVolumeChange(newVolume);
  };

  const handleMuteToggle = () => {
    if (volume > 0) {
      setPrevVolume(volume);
      onVolumeChange(0);
    } else {
      onVolumeChange(prevVolume);
    }
  };

  const getVolumeIcon = () => {
    if (volume === 0) return 'bi-volume-mute';
    return 'bi-volume-up';
  };

  return (
    <div className={styles.audioVolumeContainer}>
      <button className={styles.muteButton} onClick={handleMuteToggle}>
        <i className={`bi ${getVolumeIcon()} ${styles.volumeIcon}`}></i>
      </button>
      <input
        type="range"
        min="0"
        max="100"
        value={volume}
        onChange={handleVolumeChange}
        className={styles.volumeSlider}
      />
    </div>
  );
};

export default AudioVolume;
